import { render, staticRenderFns } from "./show-works-info.vue?vue&type=template&id=a5983558&scoped=true&"
import script from "./show-works-info.vue?vue&type=script&lang=js&"
export * from "./show-works-info.vue?vue&type=script&lang=js&"
import style0 from "./show-works-info.vue?vue&type=style&index=0&id=a5983558&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5983558",
  null
  
)

export default component.exports